import React from 'react'
import DuracionEntrevistaTotalIeC from '../Components/Home/duracion-entrevista-total-i-e-c'
import Navbar from '../Components/Navbar/Navbar'

const DuracionEntrevistaTotalIeCScreen = () => {
    return (
        <section>
            <Navbar />
            <DuracionEntrevistaTotalIeC/>
        </section>
    )
}

export default DuracionEntrevistaTotalIeCScreen
